import { render, staticRenderFns } from "./EmployeeCreateDelete.vue?vue&type=template&id=1f22a5c3&scoped=true&"
import script from "./EmployeeCreateDelete.vue?vue&type=script&lang=js&"
export * from "./EmployeeCreateDelete.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCreateDelete.vue?vue&type=style&index=0&id=1f22a5c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22a5c3",
  null
  
)

export default component.exports